// @ts-nocheck

import classNames from 'classnames';
import * as React from 'react';
type Props = {
  open: boolean;
  className: string;
};

const AccordionArrow = ({ open, className }: Props) => (
  <div className={classNames('accordion-arrow', className)}>
    <i
      className={classNames('material-icons', {
        'rotated-right': !open,
        'rotated-down': open,
      })}
    >
      <span>keyboard_arrow_right</span>
    </i>
  </div>
);

export default AccordionArrow;
